/**
 * Build quotation payload for member detail modifications
 */

/**
 * Build quotation with updated member details
 * @param {Object} policy - Current policy
 * @param {Object} updatedMember - Member with updated details
 * @returns {Object} - Quotation payload
 */
export const buildMemberUpdateQuotation = (policy, updatedMember) => {
  // Clone all policy schedule entries
  const updatedEntries = policy.quotation.policy_schedule_entries.map(entry => {
    // Check if this is the member we're updating (match by UUID or GUID)
    const isTargetMember =
      (entry.dependant && entry.dependant.uuid === updatedMember.uuid) ||
      (entry.dependant && entry.dependant.guid === updatedMember.guid) ||
      (entry.uuid === updatedMember.uuid) ||
      (entry.guid === updatedMember.guid);

    if (isTargetMember) {
      // Update this member's details
      const existingDependant = entry.dependant || entry;

      return {
        guid: existingDependant.guid,
        first_name: updatedMember.first_name,
        middle_name: updatedMember.middle_name || '',
        last_name: updatedMember.last_name,
        msisdn: updatedMember.msisdn || 'N/A',
        date_of_birth: existingDependant.date_of_birth,
        gender: updatedMember.gender,
        national_id: updatedMember.national_id || 'N/A',
        passport: updatedMember.passport || 'N/A',
        postal_address: updatedMember.postal_address || '',
        residential_address: updatedMember.residential_address || '',
        relationship: existingDependant.relationship,
        type: entry.type || existingDependant.type,
        premium_amount_in_cents: entry.premium_amount_in_cents,
        extended_premium: entry.extended_premium || 0,
        add_on_premium: entry.add_on_premium || 0,
        benefits: entry.benefits,
        uuid: existingDependant.uuid,
        additional_details: existingDependant.additional_details || {}
      };
    }

    // Keep other members unchanged
    const existingDependant = entry.dependant || entry;
    return {
      guid: existingDependant.guid,
      first_name: existingDependant.first_name,
      middle_name: existingDependant.middle_name || '',
      last_name: existingDependant.last_name,
      msisdn: existingDependant.msisdn || existingDependant.mobile_number || 'N/A',
      date_of_birth: existingDependant.date_of_birth,
      gender: existingDependant.gender,
      national_id: existingDependant.national_id || 'N/A',
      passport: existingDependant.passport || 'N/A',
      postal_address: existingDependant.postal_address || '',
      residential_address: existingDependant.residential_address || '',
      relationship: existingDependant.relationship,
      type: entry.type || existingDependant.type,
      premium_amount_in_cents: entry.premium_amount_in_cents,
      extended_premium: entry.extended_premium || 0,
      add_on_premium: entry.add_on_premium || 0,
      benefits: entry.benefits,
      uuid: existingDependant.uuid,
      additional_details: existingDependant.additional_details || {}
    };
  });

  return {
    product_guid: policy.product_guid,
    product_name: policy.product_name,
    product_code: policy.product_code,
    branch: policy.branch || 'string',
    customer_guid: policy.customer_guid,
    partner: policy.partner,
    lapse_period: policy.lapse_period || 12,
    lapse_period_granularity: policy.lapse_period_granularity || 'month',
    lapse_period_cardinality: policy.lapse_period_cardinality || 1,
    premium_granularity: policy.premium_granularity || 'month',
    premium_cardinality: policy.premium_cardinality || 1,
    policy_schedule_entries: updatedEntries,
    additional_details: policy.quotation.additional_details
  };
};
